import { Recording, RecordingPageTypes } from '../../api/user/RecordingApi.types';
import { CardSizeInfo } from '../cms/CardSizeInfo';
import { GridDataSource } from '../cms/GridDataSource';
import { RecordingCardDataSource } from './RecordingCardDataSource';
import { Log } from '@lightningjs/sdk';
import { AdultType, CardType, CmsProperty } from '../../api/models/Shared.types';
import { Backend } from '../../api/Backend';
import { ChannelModel } from '../../api/EpgApi.types';
import { CardDataSource } from '../cms/CardDataSource';
import { IRibbon2Asset } from '../../api/models/AndromeTV.types';

export class RecordingPageGridDataSource extends GridDataSource {
  private pageType: RecordingPageTypes;

  constructor(backend: Backend, channels: ChannelModel[], pageType: RecordingPageTypes, properties: CmsProperty[]) {
    // TODO grid object
    super(backend, { url: '', properties: [] }, properties, channels);
    this.backend = backend;
    this.channels = channels;
    this.pageType = pageType;
    this.sizeInfo = new CardSizeInfo(true);
  }

  override load(): Promise<RecordingPageGridDataSource> {
    return new Promise(resolve => {
      this.hasNextPage = false;
      this.backend.cachedRecordingsApi
        .recordingsForType(this.backend, this.pageType, AdultType.False)
        .then(recordings => {
          if (this.pageType === RecordingPageTypes.expires) {
            this.withRecordings(recordings, resolve);
          } else {
            this.withGroupedRecordings(recordings, resolve);
          }
        })
        .catch(err => {
          Log.error(`Error fetching recordings: ${err}`);
          resolve(this);
        });
    });
  }

  withGroupedRecordings(recordings: Recording[], resolve: any) {
    const grouped = this._groupBySeriesAndChannel(recordings);
    const cards: RecordingCardDataSource[] = [];
    const groupedToArray: Recording[][] = Object.values(grouped);
    groupedToArray.forEach(group => {
      cards.push(
        new RecordingCardDataSource(
          this.backend,
          group,
          this.channels,
          this.sizeInfo,
          this.cmsProperties,
          this.pageType
        )
      );
    });
    Promise.all(cards.map(card => card.toRibbon2Asset())).then(assets => {
      const filteredAssets: IRibbon2Asset[] = assets.filter(a => a) as IRibbon2Asset[];
      this.items = cards.map(card => card.datasource).filter(c => c) as CardDataSource[];
      this.sizeInfo.updateWithContainer(
        {
          items: filteredAssets,
          type: CardType.Landscape,
          nextPage: false,
        },
        this.cmsProperties
      );
      resolve(this);
    });
  }

  withRecordings(recordings: Recording[], resolve: any) {
    const cards: RecordingCardDataSource[] = [];
    recordings.forEach(recording => {
      cards.push(
        new RecordingCardDataSource(this.backend, [recording], this.channels, this.sizeInfo, this.cmsProperties)
      );
    });
    Promise.all(cards.map(card => card.toRibbon2Asset())).then(assets => {
      const filteredAssets: IRibbon2Asset[] = assets.filter(a => a) as IRibbon2Asset[];
      this.items = cards.map(card => card.datasource).filter(c => c) as CardDataSource[];
      this.sizeInfo.updateWithContainer(
        {
          items: filteredAssets,
          type: CardType.Landscape,
          nextPage: false,
        },
        this.cmsProperties
      );
      resolve(this);
    });
  }

  _groupBySeriesAndChannel(recordings: Recording[]) {
    if (recordings.length === 0) {
      return [];
    }
    const grouped = {};
    recordings.forEach(rec => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (grouped[`${rec.series}+${rec.channel}`] = grouped[`${rec.series}+${rec.channel}`] || []).push(rec);
    });
    return grouped;
  }
}
